import {useCallback} from 'react';
import type {CodelistRestrictor} from 'services/codelists';
import {useRestrictedCodelistsContext} from 'services/codelists';
import {useManifestationImportProps} from 'services/metadata';
import {
  getRestrictedExpressionCodelist,
  getRestrictedManifestationCodelist,
} from '../functions';
import {useMemoizedCodelistRestrictor} from './useMemoizedCodelistRestrictor';

export const useExpressionAndManifestationCodelistRestrictor = (
  manifestationId: string,
  expressionId: string,
): CodelistRestrictor => {
  const importProps = useManifestationImportProps(
    manifestationId,
    expressionId,
  );
  const {getRestrictedCodelist: getOuterRestrictedCodelist} =
    useRestrictedCodelistsContext();

  const restrict = useCallback<CodelistRestrictor>(
    codelist => {
      const outerCodelist = getOuterRestrictedCodelist(codelist);
      const expressionCodelist = getRestrictedExpressionCodelist(
        importProps,
        outerCodelist,
      );
      return getRestrictedManifestationCodelist(
        importProps,
        expressionCodelist,
      );
    },
    [getOuterRestrictedCodelist, importProps],
  );

  return useMemoizedCodelistRestrictor(restrict);
};
